<template>
  <div class="content">
    <div class="mask" v-show="maskShow"></div>
    <div class="banner">
      <img src="../../img/mobile/Banner.png" />
    </div>
    <div class="download android" v-if="androidFlag">
      <img src="../../img/mobile/Android.png" />
      <p class="nameWay">Android</p>
      <button @click="download()">点击下载</button>
    </div>
    <div class="download iphone" v-if="iosFlag">
      <img src="../../img/mobile/iphone.png" />
      <p class="nameWay">iphone</p>
      <button @click="download()">点击下载</button>
    </div>
    <downloadTip :maskShow="maskShow"></downloadTip>
  </div>
</template>

<script>
import downloadTip from "../../components/mobile/downloadTip";
export default {
  components: {
    downloadTip
  },
  data() {
    return {
      maskShow: false,
      androidFlag: false,
      iosFlag: false
    };
  },
  methods: {
    download() {
      function is_weixin() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) === "micromessenger") {
          return true;
        } else {
          return false;
        }
      }

      var browser = {
        versions: (function() {
          var u = navigator.userAgent;
          return {
            // 移动终端浏览器版本信息
            trident: u.indexOf("Trident") > -1, // IE内核
            presto: u.indexOf("Presto") > -1, // opera内核
            webKit: u.indexOf("AppleWebKit") > -1, // 苹果、谷歌内核
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") === -1, // 火狐内核
            mobile:
              !!u.match(/AppleWebKit.*Mobile/i) ||
              !!u.match(
                /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/
              ), // 是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, // android终端或者uc浏览器
            iPhone: u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1, // 是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("iPad") > -1, // 是否iPad
            webApp: u.indexOf("Safari") === -1, // 是否web应该程序，没有头部与底部
            webview:
              !(u.match(/Chrome\/([\d.]+)/) || u.match(/CriOS\/([\d.]+)/)) &&
              u.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
            Safari: u.indexOf("Safari") > -1,
            QQbrw: u.indexOf("MQQBrowser") > -1 // QQ浏览器
          };
        })()
      };
      console.log(is_weixin(), "is_weixin");
      // 微信内置浏览器打开，只是显示遮罩层，其他浏览器进行连接跳转

      var urls = {
        android:
          "https://ding-talk-platform.bellecdn.cn/download/android/1576477801268@larkplus-release.apk",
        ios:
          "itms-services://?action=download-manifest&url=https://ding-talk-platform.bellecdn.cn/download/ios/ding1.plist"
      };
      if (is_weixin()) {
        if (browser.versions.android) {
          this.maskShow = true;
          this.androidFlag = true;
        } else if (
          browser.versions.iPhone ||
          browser.versions.iPad ||
          browser.versions.ios
        ) {
          this.maskShow = true;
          this.iosFlag = true;
        }
      } else {
        if (
          browser.versions.iPhone ||
          browser.versions.iPad ||
          browser.versions.ios
        ) {
          this.maskShow = false;
          this.iosFlag = true;
          window.location.href = urls.ios;
        } else if (browser.versions.android) {
          this.maskShow = false;
          this.androidFlag = true;
          window.location.href = urls.android;
        }
      }
    }
  },
  mounted() {
    window.scroll(0, 0);
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      this.androidFlag = !this.androidFlag;
    } else if (isiOS) {
      this.iosFlag = !this.iosFlag;
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  .banner {
    height: 3.79rem;
    img {
      width: 7.5rem;
      height: 3.79rem;
    }
  }
  .download {
    width: 3.3rem;
    height: 3.55rem;
    background: rgba(250, 250, 250, 1);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    top: 1rem;
  }
  .android {
    margin-right: 0.3rem;
    img {
      width: 0.8rem;
      height: 1rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0.49rem;
    }
  }
  .iphone {
    img {
      width: 0.8rem;
      height: 0.97rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0.45rem;
    }
  }
  .nameWay {
    height: 0.28rem;
    font-size: 0.4rem;
    font-family: Helvetica;
    color: rgba(153, 153, 153, 1);
    line-height: 0.28rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    top: 1.7rem;
  }
  button {
    width: 2rem;
    height: 0.66rem;
    background: rgba(34, 142, 243, 1);
    border-radius: 0.04rem;
    border: 0.01rem solid rgba(34, 142, 243, 1);
    text-align: center;
    font-size: 0.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0.4rem;
    outline: none;
  }
  .weixin-tip {
    left: 0;
    top: 0;
    bottom: 0;
    width: 3.48rem;
    position: absolute;
    z-index: 300;
  }
  .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 1);
    opacity: 0.4;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/download.vue